import { gql } from '@apollo/client';

export const GET_MATCHING_CANDIDATES = gql`
  query GetMatchingCandidates($roleId: String!) {
    vm {
      matchingCandidates(roleId: $roleId) {
        applicationId
        name
        email
        status
        dateSubmitted
        profile {
          profileId
          preferredName
          lastName
          dateOfBirth
        }
        applicationRoles {
          applicationRoleId
          role {
            activityRoleId
            name
          }
          status
        }
        funnel {
          name
        }
      }
    }
  }
`;
